import { styled, Typography } from '@mui/material';

export const PostReactions = styled('div')<{ isPostDetails?: boolean }>`
  height: 28px;
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  justify-content: 'flex-end';
  align-items: 'flex-end';

  &:hover .post-hover-reaction {
    display: flex;
  }
`;

export const PostActionBar = styled('div')<{ isPostDetails?: boolean }>`
  width: 100%;
  height: 28px;
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  justify-content: space-around;
`;

export const Separator = styled('div')<{ isPostDetails?: boolean }>`
  width: ${({ isPostDetails }) => (isPostDetails ? '100%' : '361px')};
  height: 1px;
  background: ${({ theme }) => theme.palette.white.main};
  margin: 8px auto;
`;

export const TitleReactions = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.secondary.light};
`;

export const PostHoverReactions = styled('div')`
  position: absolute;
  width: 72px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  background: ${({ theme }) => theme.palette.white.main};
  column-gap: 12px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  display: none;
`;

export const ReactionsContainer = styled('div')`
  position: absolute;
  margin-top: -48px;
  height: 50px;
  width: 72px;
  display: none;
`;

export const LikesCounterContainer = styled('div')`
  width: fit-content;
  min-width: 16px;

  &:hover .likes-author-view {
    display: flex;
  }
`;

export const LikesCounter = styled('div')<{ isPostDetails?: boolean }>`
  width: 100%;
  color: ${({ theme }) => theme.palette.secondary.light};
  margin-top: 16px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: ${({ isPostDetails }) => isPostDetails && 'right'};

  &:hover {
    text-decoration: underline;
  }
`;

export const LikesAuthorView = styled('div')<{
  likesAmount: number;
  isPostDetails?: boolean;
  isAutoPost?: boolean;
}>`
  background: ${({ theme }) => theme.palette.white.main};
  padding: 8px;
  position: absolute;
  width: 132px;
  max-height: 232px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-top: ${({ likesAmount, isAutoPost }) =>
    likesAmount && `calc(${isAutoPost ? '-30px' : '-18px'} - ${likesAmount - 1}*20px)`};
  display: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  right: ${({ isPostDetails }) => isPostDetails && '0'};
  margin-right: ${({ isPostDetails }) => isPostDetails && '33px'};
  z-index: 1;
`;

export const AuthorName = styled('div')`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
`;
export const PublishedTime = styled('div')`
  margin-top: -5px;
  color: ${({ theme }) => theme.palette.primary.p050};
  font-weight: normal;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Reaction = styled('div')``;

export const Wrap = styled('div')<{ isPostDetails?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isPostDetails }) => (isPostDetails ? 'end' : 'start')};
`;

export const ActionsW = styled('div')`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  top: -8px;
  width: min-content;
`;

export const IconW = styled('div')`
  position: relative;
  height: 20px;
`;

export const CountW = styled('span')`
  position: absolute;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.8;
`;

export const popoverStyles = {
  borderRadius: '8px',
  width: '120px',
  paddingLeft: '8px',

  '& .MuiList-root': {
    padding: 0,
    display: 'grid',
    gap: '16px',
  },

  '@media (max-width: 1023px)': {
    width: 'calc(100% - 16px)',
    maxWidth: 'calc(100% - 16px)',
    left: '8px !important',
  },
};

export const TopBarW = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 5px;
`;

export const AuthorDetailsW = styled('div')<{ isAutomatedPost?: boolean }>`
  cursor: ${({ isAutomatedPost }) => (isAutomatedPost ? 'default' : 'pointer')};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
`;

export const AuthorNameW = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const PostHeaderRightW = styled('div')`
  display: flex;
  flex-direction: row;
`;
